import { notAllowedWord, reservedValues } from '../../../../common/formElements/reservedKeywords';
export const textFieldValidate = (value, field, isConstructorForm) => {
  console.log('value', value);
  const { required, validation } = field;
  if (!validation) {
    return;
  }

  const { min, max, regex } = validation;
  let error = '';
  if (isConstructorForm) {
    if (value || value.length > 0) {
      if (min && !(value.length >= min)) {
        error = `Must be ${min} characters. Currently at ${value.length} characters `;
      } else if (max && !(value.length <= max)) {
        error = `Must be at least ${max} characters. Currently at ${value.length} characters `;
      }
    } else {
      console.log('No value is given');
    }
  } else {
    if (!value) {
      if (required) {
        error = 'This field is required';
      }
    } else {
      //TODO: Need to create common method for min/max check refer line no. 13 and 29
      console.log('value', value);
      value = `${value}`.toLowerCase();
      console.log('value', value);
      if (min && !(value.length >= min)) {
        error = `Must be ${min} characters. Currently at ${value.length} characters `;
      } else if (max && !(value.length <= max)) {
        error = `Must be at least ${max} characters. Currently at ${value.length} characters `;
      } else if (reservedValues.includes(value)) {
        error = `This is reserved word please use another`;
      } else if (notAllowedWord.includes(value)) {
        error = `This type of word not allowed`;
      }
    }
  }
  return error;
};

export const requiredValidation = (value, field) => {
  const { required } = field;
  let error;
  if (required && !value) {
    error = 'This field is required';
  }
  return error;
};
